export default {
  de: {
    name: 'Name',
    add: 'Frage hinzufügen',
    destroy: 'Bereich Löschen',
  },
};
